import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import viewmore from "../../../assets/images/HomePage/arrowR.svg";
import left from "../../../assets/images/HomePage/arrowL.svg";
import backbtn from "../../../assets/images/backbutton.svg";
import {
  GetProductAlsoLike,
  GetProductJustViewdd,
  GetProductNewDrops,
  GetProductFromSeller,
  GetProductTopPicks,
  GetLibasProduct,
  GetAllChanel,
  GetAllAmina,
  GetAllPradaReEdition,
  GetAllChanelBoy,
  GetAllBottega,
  GetAllHermes,
  IsProductAlsoLike,
  IsDrops,
  IsJustView,
  IsTopPicks,
  IsProductFromSeller,
  IsProductLibas,
  GetAllProductVintage,
  IsVintage,
  IsChanel,
  IsAmina,
  IsPradaReEdition,
  IsChanelBoy,
  IsBottega,
  IsHermes,
  IsBirkin,
  GetAllBirkin,
  GetAllBurberry,
  IsBurberry,
  GetAllLV,
  GetAllDG,
  GetAllMM,
  GetAllZadig,
  GetAllDisel,
  GetAllGucci,
  IsDG,
  IsGucci,
  IsDisel,
  IsLV,
  IsMM,
  IsZadug,
  setProProducts,
} from "../../../features/Products/ProductSlice";

import {
  db,
  collection,
  onSnapshot,
  query,
  orderBy,
  documentId,
} from "../../../utils/firebase/firebase.utils";
import { useTranslation } from "react-i18next";
import { useEffect, useContext, useState } from "react";
import { UserContext } from "../../../context/user.context";
import SignIn from "../../SignIn/SignIn";
import DownloadModal from "../../Modals/DownloadModal";
import ForgetPassword from "../../ForgetPassword/ForgetPassword";
import SignUp from "../../SignUp/SignUp";
import ProductCard from "../../Static/Shared/ProductCard";
import { getDocs, limit, where } from "firebase/firestore";
import LoadingComp from "../LoadingComp";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import viewall from "../../../assets/images/view-all.svg";
function WeTrust() {
  const { t, i18n } = useTranslation();
  const proSeller =
    process.env.REACT_APP_ENV === "development"
      ? ["pzDwv4q3qkac6iqZcTWMTMKGdCM2"]
      : [
          // "HQNUnqBgeCeZaBKbqUiDy0MbSI82",
          // "Aprj75LHckQ7ZXFXYXgREkzgM1f2",
          // "0eXiw1AHOTOvfRsznBaGly2ncMU2",
          // "PryaWIyD6EQI29kK9GSPNu2CAuD2",
          "q8uMmbdiEDZhf1TlXFCTpySUybD2",
          "u8Yp8EsEqBhmDCZCg6hjUE45raK2",
          "Tj0QRAwEVIXC242Z2yww4CkrTiG3",
          "4j3vC2wiqBd3mEzSKpYD5VyGXEo1",
          "9zbHHx5Gbud69Mo2u56yjZ7XzoJ2",
          "Kr4zn7IulFSPdNaI0wgdrsltFId2",
          "UsfWz3BuiXPzDFzsCL1LzYj1JmW2",
          "HQNUnqBgeCeZaBKbqUiDy0MbSI82",
          "0eXiw1AHOTOvfRsznBaGly2ncMU2",
          "Aprj75LHckQ7ZXFXYXgREkzgM1f2",
        ];
  const navigate = useNavigate();
  const { flags } = useSelector((store) => store.flags);
  const { proProducts } = useSelector((store) => store.allproducts);
  const dispatch = useDispatch();
  const { currentUser } = useContext(UserContext);
  //const productsViewedLength = productsViewed.slice(0, 4).length;
  const [showDownload, setShowDownload] = useState(false);
  const [showSignin, setShowSignin] = useState(false);
  const [signUp, setSignUp] = useState(false);
  const [forgetpassword, setForgetpassword] = useState(false);

  var isFlash = false;

  if (flags.filter((flag) => flag.id === "offers")[0]) {
    const endDate = flags.filter((flag) => flag.id === "offers")[0]
      .endFlashSale;
    const startDate = flags.filter((flag) => flag.id === "offers")[0]
      .startFlashSale;
    isFlash =
      "toDate" in endDate && "toDate" in startDate
        ? flags.filter((flag) => flag.id === "offers")[0].isFlashSale &&
          startDate.toDate() <= Date.now() &&
          endDate.toDate() >= Date.now()
        : false;
  }

  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
    };
  } else {
    var arabStyle = {};
  }

  const [allProProducts, setProProducts] = useState([]);

  function sortProductsByDate(ids, products) {
    // Sort the ids array by date in descending order
    // ids.sort((a, b) => {
    //   return b.date.seconds - a.date.seconds || b.date.nanoseconds - a.date.nanoseconds;
    // });

    // Create a map of product IDs to their indices in the sorted ids array
    const idToIndex = new Map(ids.map((id, index) => [id.id, index]));

    // Sort the products array based on the indices in the sorted ids array (descending)
    products.sort((a, b) => {
      return idToIndex.get(b.id) - idToIndex.get(a.id);
    });

    return products;
  }
  async function getProducts() {
    const productsRef = collection(db, "product");
    const q = query(
      productsRef,
      where("status", "==", "Live"),
      where("idUser", "in", proSeller),
      // orderBy("date", "desc"),
      where("likesCount", "!=", 0),
      orderBy("likesCount", "desc"),
      // Fetch more products to get variety
      limit(50)
    );
    const querySnapshot = await getDocs(q);

    const products = [];
    querySnapshot.forEach((doc) => {
      products.push({ id: doc.id, ...doc.data() });
    });

    return products;
  }

  function shuffleArray(array) {
    const newArray = [...array]; // Create a copy to avoid modifying the original
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  }

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const products = await getProducts();

        if (products?.length === 0) return;

        // Shuffle all fetched products
        const shuffledProducts = shuffleArray(products);

        // Take only the first 10 cards
        const displayProducts = shuffledProducts.slice(0, 10);

        dispatch(setProProducts(displayProducts));
        setProProducts(displayProducts);
      } catch (error) {
        console.error("Error retrieving products:", error);
      }
    };

    fetchProducts();
  }, []);
  console.log(allProProducts, "all trusted products");
  function RightArrow() {
    const { isLastItemVisible, scrollNext } = useContext(VisibilityContext);

    return !isLastItemVisible ? (
      <div
        disabled={isLastItemVisible}
        className="align-items-center d-flex"
        onClick={() => scrollNext()}
      >
        {allProProducts.length > 4 ? (
          // <img src={viewmore} className="plusbtn" />
          <div class="image-container-arrow">
            <img
              src={left}
              alt="right arrow"
              className="arrow-default rotate180"
            />
            <img src={viewmore} alt="right arrow" className="arrow-hover " />
          </div>
        ) : null}
      </div>
    ) : (
      <></>
    );
  }
  function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = useContext(VisibilityContext);

    return !isFirstItemVisible ? (
      <div
        disabled={isFirstItemVisible}
        className="align-items-center d-flex"
        onClick={() => scrollPrev()}
      >
        {allProProducts.length > 4 ? (
          // <img src={left} className="plusbtn me-3" />
          <div class="image-container-arrow">
            <img src={left} alt="right arrow" className="arrow-default" />
            <img
              src={viewmore}
              alt="right arrow"
              className="arrow-hover rotate180"
            />
          </div>
        ) : null}
      </div>
    ) : (
      <></>
    );
  }

  // var arr = productsViewed.filter((name) => products.includes(name.id));

  // var ViewdArray = productsViewed.map(
  //   (productsView) => products.filter((name) => name.id == productsView.id)[0]
  // );

  useEffect(() => {
    dispatch(GetProductJustViewdd([]));
    dispatch(GetProductAlsoLike([]));
    dispatch(GetProductFromSeller([]));
    dispatch(GetProductNewDrops([]));
    dispatch(GetProductTopPicks([]));
    //// dispatch(GetAllProductViewd([]));
    dispatch(GetLibasProduct([]));
    dispatch(GetAllProductVintage([]));
    dispatch(GetAllChanel([]));
    dispatch(GetAllAmina([]));
    dispatch(GetAllPradaReEdition([]));
    dispatch(GetAllChanelBoy([]));
    dispatch(GetAllBottega([]));
    dispatch(GetAllHermes([]));
    dispatch(GetAllBirkin([]));
    dispatch(GetAllBurberry([]));
    dispatch(IsBurberry(false));

    dispatch(GetAllDG([]));
    dispatch(IsDG(false));

    dispatch(GetAllLV([]));
    dispatch(IsLV(false));

    dispatch(GetAllDisel([]));
    dispatch(IsDisel(false));

    dispatch(GetAllGucci([]));
    dispatch(IsGucci(false));

    dispatch(GetAllMM([]));
    dispatch(IsMM(false));

    dispatch(GetAllZadig([]));
    dispatch(IsZadug(false));
    dispatch(IsJustView(false));
    dispatch(IsDrops(false));
    dispatch(IsTopPicks(false));
    dispatch(IsProductFromSeller(false));
    dispatch(IsProductAlsoLike(false));
    dispatch(IsProductLibas(false));
    dispatch(IsVintage(false));
    dispatch(IsChanel(false));
    dispatch(IsAmina(false));
    dispatch(IsPradaReEdition(false));
    dispatch(IsChanelBoy(false));
    dispatch(IsBottega(false));
    dispatch(IsHermes(false));
    dispatch(IsBirkin(false));
  }, []);
  // console.log('productsViewed',productsViewed)

  // allProProducts.length <= 4  ? null :
  return (
    <>
      {/* {console.log("allProProducts", allProProducts)} */}
      {signUp && (
        <SignUp
          signUp={signUp}
          setSignUp={setSignUp}
          handleSignIn={showSignin}
        />
      )}
      {forgetpassword && (
        <ForgetPassword
          forgetShow={forgetpassword}
          handleforgetShow={setForgetpassword}
          handleSignIn={showSignin}
        />
      )}
      {showSignin && (
        <SignIn
          signIn={showSignin}
          handleSignIn={setShowSignin}
          handleSignUp={setSignUp}
          handleForgetpassword={setForgetpassword}
        />
      )}
      <div className=" show-modal-download">
        {showDownload && (
          <DownloadModal show={showDownload} setShow={setShowDownload} />
        )}
      </div>
      <div className="d-flex align-items-center">
        <h1
          className={`title-section px-md-5  ${
            i18n.language == "en" ? `text-center` : `text-startAr`
          }`}
        >
          {t("WeTrust")}
        </h1>
        <div style={{ flexGrow: 1 }} />
        <a
          className={`d-flex justify-content-center shoptopick px-lg-0 px-3  pt-lg-5  me-md-5  ${
            i18n.language == "en" ? `text-center` : `text-startAr`
          }`}
          onClick={
            () =>
              navigate(`/products?topic=proSeller`) &
              window.scrollTo({ top: 0, left: 0, behavior: "instant" })
            // dispatch(IsTopPicks(true)) &
            // navigate(`/products?topic=TopPicks`) &
            // dispatch(SetSearch("")) &
            // window.scrollTo({ top: 0, left: 0, behavior: "instant" })
          }
          style={arabStyle}
          aria-label="Shop Top Picks - View All Top Picks"
        >
          {i18n.language == "en" ? (
            <>
              <div
                className={`me-2 shoptopick ${
                  i18n.language == "en" ? `text-start` : `text-startAr`
                }`}
              >
                {t("viewall")}
              </div>

              <img
                src={viewall}
                style={{ width: "19px" }}
                className="plusbtn"
                alt="main"
              />
            </>
          ) : (
            <>
              <img
                src={backbtn}
                style={{ width: "98px" }}
                className="plusbtn"
                alt="main"
              />
            </>
          )}
        </a>
      </div>

      <h2 className="sub-section px-md-5 pt-md-2 ">{t("trust-sub1")}</h2>
      {!allProProducts || allProProducts.length == 0 ? (
        <LoadingComp heightcomp="newdropsheight" />
      ) : (
        <div>
          {allProProducts.length > 4 ? (
            <>
              <div className="d-md-block d-none">
                <div
                  className="  padding-inlineCards px-md-5 px-0 pb-md-5"
                  dir={i18n.dir("en")}
                >
                  <ScrollMenu
                    LeftArrow={LeftArrow}
                    RightArrow={RightArrow}
                    className="padding-inlineCards px-md-5 px-0  pt-md-5 pb-md-5 d-md-block d-none"
                    id="style-2"
                  >
                    {allProProducts?.slice(0, 15).map((card) => (
                      <ProductCard
                        card={card}
                        currentUser={currentUser}
                        isFlash={isFlash}
                        allTrusted={true}
                      />
                    ))}
                  </ScrollMenu>

                  {/* </div> */}
                </div>
              </div>
              <div className="container-fluid px-0 pt-md-0 pt-2 me-0 d-md-none d-flex ">
                <div
                  className="  d-flex flex-row  scroll flex-nowrap padding-inlineCards px-md-5 px-0  pt-md-5 pb-md-5"
                  dir={i18n.dir("en")}
                >
                  {allProProducts.slice(0, 4).map((card) => (
                    <ProductCard
                      card={card}
                      currentUser={currentUser}
                      isFlash={isFlash}
                      allTrusted={true}
                    />
                  ))}
                  {/* </div> */}
                </div>
              </div>
            </>
          ) : (
            <div className="container-fluid p-0 me-0 d-flex">
              {allProProducts.slice(0, 4).map((card) => (
                <ProductCard
                  card={card}
                  currentUser={currentUser}
                  isFlash={isFlash}
                  setShowSignin={setShowSignin}
                  allTrusted={true}
                />
              ))}
            </div>
          )}
        </div>
      )}
      {/* <div className="text-center pt-lg-5 pt-4">
        <button
          className="btn-shop buttonH"
          onClick={() =>
            dispatch(SetSelectdPage(0))&
            dispatch(SetSizeFilter([]))&
            dispatch(SortProducts(''))&
            dispatch(SetTopSizeFilter([]))&
            dispatch(IsJustView(true)) &
            navigate(`/products?topic=JustViewed`) &
            window.scrollTo({ top: 0, left: 0, behavior: "instant" })
          }
          aria-label="View Recently Viewed Products"
        >
         {t( "VIEW ALL")}
        </button>
      </div> */}
      <br></br>
    </>
  );
}

export default WeTrust;
